import { render, staticRenderFns } from "./PairedProductActions.vue?vue&type=template&id=24282647&"
import script from "./PairedProductActions.vue?vue&type=script&lang=js&"
export * from "./PairedProductActions.vue?vue&type=script&lang=js&"
import style0 from "./PairedProductActions.vue?vue&type=style&index=0&id=24282647&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports